"use client";

import Link from "next/link";

export default function Error({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <main className="auth">
      <div className="auth-card">
        <h1>Da ist etwas schiefgelaufen</h1>
        <p>Beim Laden dieser Seite ist ein Fehler aufgetreten. Bitte versuche es noch einmal.</p>
        <button type="button" onClick={reset}>Erneut versuchen</button>
        <Link href="/" className="auth-link">Zur Startseite</Link>
      </div>
    </main>
  );
}
